export default "__VITE_ASSET__CR9hWuBL__"